import {
  eyeIcon,
  ExternalLinkIcon,
  LoadIcon,
  save,
  saveAs,
  TrashIcon,
} from "@excalidraw/excalidraw/components/icons";
import { MainMenu } from "@excalidraw/excalidraw/index";
import React from "react";

import { isDevEnv } from "@excalidraw/common";

import type { Theme } from "@excalidraw/element/types";

import { LanguageList } from "../app-language/LanguageList";

import { saveDebugState } from "./DebugCanvas";

export const AppMainMenu: React.FC<{
  onCollabDialogOpen: () => any;
  isCollaborating: boolean;
  isCollabEnabled: boolean;
  theme: Theme | "system";
  refresh: () => void;
  onCloudSave: () => void;
  onCloudSaveAs: () => void;
  onCloudOpen: () => void;
  onCloudDelete: () => void;
  hasCloudDrawing: boolean;
  onLogout: () => void;
  userEmail: string | null;
}> = React.memo((props) => {
  return (
    <MainMenu>
      <MainMenu.DefaultItems.LoadScene />
      <MainMenu.DefaultItems.SaveToActiveFile />
      <MainMenu.DefaultItems.Export />
      <MainMenu.DefaultItems.SaveAsImage />
      {props.isCollabEnabled && (
        <MainMenu.DefaultItems.LiveCollaborationTrigger
          isCollaborating={props.isCollaborating}
          onSelect={() => props.onCollabDialogOpen()}
        />
      )}
      <MainMenu.DefaultItems.CommandPalette className="highlighted" />
      <MainMenu.DefaultItems.SearchMenu />
      <MainMenu.DefaultItems.Help />
      <MainMenu.DefaultItems.ClearCanvas />
      <MainMenu.Separator />
      <MainMenu.Item icon={save} onSelect={props.onCloudSave}>
        Сохранить на сервер
      </MainMenu.Item>
      <MainMenu.Item icon={saveAs} onSelect={props.onCloudSaveAs}>
        Сохранить копию на сервер
      </MainMenu.Item>
      <MainMenu.Item icon={LoadIcon} onSelect={props.onCloudOpen}>
        Открыть с сервера
      </MainMenu.Item>
      {props.hasCloudDrawing && (
        <MainMenu.Item icon={TrashIcon} onSelect={props.onCloudDelete}>
          Удалить серверный файл
        </MainMenu.Item>
      )}
      <MainMenu.Item icon={ExternalLinkIcon} onSelect={props.onLogout}>
        {props.userEmail ? `Выйти (${props.userEmail})` : "Выйти"}
      </MainMenu.Item>
      <MainMenu.Separator />
      {isDevEnv() && (
        <>
          <MainMenu.Item
            icon={eyeIcon}
            onSelect={() => {
              if (window.visualDebug) {
                delete window.visualDebug;
                saveDebugState({ enabled: false });
              } else {
                window.visualDebug = { data: [] };
                saveDebugState({ enabled: true });
              }
              props?.refresh();
            }}
          >
            Visual Debug
          </MainMenu.Item>
          <MainMenu.Separator />
        </>
      )}
      <MainMenu.DefaultItems.Preferences />
      <MainMenu.DefaultItems.ToggleTheme allowSystemTheme theme={props.theme} />
      <MainMenu.ItemCustom>
        <LanguageList style={{ width: "100%" }} />
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.ChangeCanvasBackground />
    </MainMenu>
  );
});
